<template>
  <div>
    <b-table
      v-if="client.cards.length"
      class="b-table"
      striped
      responsive="sm"
      hover
      :items="client.cards"
      :fields="tableFields"
    >
      <template #cell(buy_date)="row">
        {{ row.item.buy_date | moment }}
      </template>
      <template #cell(activation_date)="row">
        {{ row.item.activation_date | moment }}
      </template>
      <template #cell(expiration_date)="row">
        {{ row.item.expiration_date | moment }}
      </template>
      <template #cell(status)="row">
        {{ row.item.status | translate }}
      </template>
      <template #cell(amount)="row"> {{ row.item.amount }} грн </template>
      <template #cell(visits)="row">
        {{ row.item.visits }} / {{ row.item.total_visits }}
        <b-button
          @click="row.toggleDetails"
          size="sm"
          class="ml-2"
          variant="outline-success"
        >
          Детальніше
        </b-button>
      </template>
      <template #cell(Дії)="row">
        <b-button
          v-if="row.item.status === 'EXPIRED'"
          size="sm"
          @click="renewCard(row.item)"
          variant="outline-success"
        >
          Відновити
        </b-button>
        <b-button
          variant="outline-danger"
          size="sm"
          class="ms-3"
          @click="deleteCard(row.item)"
        >
          Видалити
        </b-button>
      </template>
      <template #row-details="row">
        <b-card v-if="row.item.visits_obj.length">
          <b-table :items="row.item.visits_obj" :fields="visitFields">
            <template #cell(time)="row">
              {{ row.item.time | moment }}
            </template>
            <template #cell(location_id)="row">
              {{ row.item.location_id | clubSort }}
            </template>
            <template #cell(admin)="row">
              {{ row.item.admin.name }} {{ row.item.admin.surname }}
            </template>
          </b-table>
        </b-card>
      </template>
    </b-table>
    <div v-else class="p-4 fs-4">Карт немає :(</div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "CardsTable",
  props: {
    client: Object,
  },
  computed: {
    ...mapState(["user"]),
    tableFields() {
      if (this.user[0].role === "superadmin") {
        return [
          { key: "product.name", label: "Назва" },
          { key: "buy_date", label: "Дата покупки" },
          { key: "activation_date", label: "Дата активації" },
          { key: "expiration_date", label: "Дата закінчення" },
          { key: "status", label: "Статус" },
          { key: "visits", label: "Візитів" },
          { key: "amount", label: "Сума покупки" },
          { key: "Дії" },
        ];
      }
      return [
        { key: "product.name", label: "Назва" },
        { key: "buy_date", label: "Дата покупки" },
        { key: "activation_date", label: "Дата активації" },
        { key: "expiration_date", label: "Дата закінчення" },
        { key: "status", label: "Статус" },
        { key: "visits", label: "Візитів" },
        { key: "amount", label: "Сума покупки" },
      ];
    },
    visitFields() {
      if (this.user[0].role === "superadmin") {
        return [
          { key: "time", label: "Час" },
          { key: "location_id", label: "Клуб" },
          { key: "admin", label: "Адмін" },
          { label: "Видалення" },
        ];
      } else {
        return [
          { key: "time", label: "Час" },
          { key: "location_id", label: "Клуб" },
          { key: "admin", label: "Адмін" },
        ];
      }
    },
  },
  methods: {
    async deleteCard(card) {
      let result = confirm(`Видалити карту ${card.product.name}?`);
      if (!result) return;
      await this.$api.activecards
        .deleteCard(card.id)
        .then(() => {
          this.$emit("showModal", "Карта видалена!", "green");
          this.$emit("refresh");
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.$emit("showModal", "В цій картці є візити!", "red");
          }
        });
    },
    async renewCard(card) {
      let result = confirm(`Відновити карту ${card.product.name}?`);
      if (!result) return;
      await this.$api.activecards.renewCard(card.id).then(() => {
        this.$emit("showModal", "Карта відновлена!", "green");
        this.$emit("refresh");
      });
    },
  },
  filters: {
    moment: function (date) {
      if (!date) {
        return "";
      }
      return moment(date).format("DD-MM-YY HH:mm");
    },
    translate: function (status) {
      if (status === "EXPIRED") {
        return "Закінчена";
      } else if (status === "ACTIVE") {
        return "Активна";
      } else if (status === "NOT ACTIVE") {
        return "Не активована";
      }
      return status;
    },
    clubSort: function (club) {
      if (club === 1) {
        return "Василенко, 9";
      } else if (club === 2) {
        return "Острозького, 55";
      }
    },
  },
};
</script>

<style scoped></style>
